import React, { useEffect } from "react";
import { CommentInterface } from "../../../../store/mine_craft/commentsSlice";
import { Button, Form, Input, Switch } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

interface propsInterface {
  params?: CommentInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='body' label="Body">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item label="Hidden" name='hidden' valuePropName='checked'>
        <Switch
          checkedChildren={<EyeInvisibleOutlined />}
          unCheckedChildren={<EyeOutlined />}
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
